let apiUrl = 'https://my.fresk.app/api'; // Prod API URL
if (location.hostname === 'localhost' || location.hostname === '127.0.0.1')
	apiUrl = 'http://localhost:8190'; // Local API URL
if (location.host === 'rc.fresk.app')
	apiUrl = 'https://rc.fresk.app/api'; // rc API URL

let micrositeUrl = 'https://my.fresk.app/microsite'; // Prod Microsite URL
if (location.hostname === 'localhost' || location.hostname === '127.0.0.1')
	micrositeUrl = 'http://localhost:8081/microsite'; // Local Microsite URL
if (location.host === 'rc.fresk.app')
	micrositeUrl = 'https://rc.fresk.app/microsite'; // rc Microsite URL

module.exports = {
	apiUrl: apiUrl,
	micrositeUrl: micrositeUrl
};